import { makeAutoObservable } from 'mobx'
import { createContext } from 'react'
import { MaybeBraveNavigator } from 'screens/ProseEdit/components/RealtimeProvider/SafariBraveWSModal/Types'

const { userAgent, brave } = navigator as MaybeBraveNavigator

export class System {
  // Note: ua-parser-js does not accurately detect Brave.
  // This is because ua-parser-js uses a simple regex against the user agent string
  // and Brave does not have a user agent string anymore. Instead, you have to use
  // `navigator.brave` as we are doing below.
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#which_part_of_the_user_agent_contains_the_information_you_are_looking_for
  isBrave = !!brave
  isSafari = userAgent.includes('Safari') && !userAgent.includes('Chrome') && !userAgent.includes('Chromium')

  constructor() {
    makeAutoObservable(this)
  }
}

export const SystemContext = createContext<System>(new System())
